import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

export interface CustomTab {
  name: string;
  value: number;
  icon?: string;
  isDisabled?: boolean;
  tooltip?: string;
}

@Component({
  selector: 'qa-custom-tabs',
  templateUrl: './custom-tabs.component.html',
  styleUrls: ['./custom-tabs.component.scss'],
  imports: [TranslateModule, MatIconModule, MatTooltip],
})
export class CustomTabsComponent implements OnInit {
  @Output() tabSelected = new EventEmitter<number>();
  @Input() tabs: CustomTab[];
  @Input() defaultSelected: number;
  selectedTab: CustomTab;

  ngOnInit(): void {
    if (this.defaultSelected || this.defaultSelected === 0) {
      this.selectedTab = this.tabs.find(
        (t) => t.value === this.defaultSelected
      );
    }
  }

  selectTab(tab: CustomTab) {
    if (tab.isDisabled) {
      return;
    }
    this.selectedTab = tab;
    this.tabSelected.emit(tab.value);
  }
}
